// Currency conversion utilities
import { getCurrentLanguage } from './languageSwitcher';

// Fixed exchange rate: 1 EUR = 25 CZK (approximately)
// In a real application, you might want to fetch this from an API
export const CZK_TO_EUR_RATE = 0.04; // 1 CZK = 0.04 EUR
export const EUR_TO_CZK_RATE = 25; // 1 EUR = 25 CZK

/**
 * Convert CZK to EUR
 * @param {number|string} czkAmount - Amount in CZK
 * @returns {number} Amount in EUR
 */
export const convertCzkToEur = (czkAmount) => {
  const numericAmount = typeof czkAmount === 'string' 
    ? parseFloat(czkAmount.replace(/[^\d,.-]/g, '').replace(',', '.'))
    : parseFloat(czkAmount);
    
  if (isNaN(numericAmount)) return 0;
  
  return Math.round(numericAmount * CZK_TO_EUR_RATE);
};

/**
 * Format price with appropriate currency symbol
 * @param {number|string} price - Price amount
 * @param {string} locale - Current locale
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, locale = null) => {
  const currentLocale = locale || getCurrentLanguage();
  
  // If Czech locale, show CZK
  if (currentLocale === 'cs-CZ') {
    return `${price} Kč`;
  }

  if (currentLocale === "pl-PL") {
    return `${price} zł`;
  }

  if (currentLocale === "sk-SK") {
    return `${price} €`;
  }

  if (currentLocale === "hu-HU") {
    return `${price} Ft`;
  }
  
  // For other locales, convert to EUR
  //const eurPrice = convertCzkToEur(price);
  return `${price}`;
};

/**
 * Get exchange rate text for current locale
 * @param {string} locale - Current locale
 * @returns {string} Exchange rate text or empty string for CZK
 */
export const getExchangeRateText = (locale = null) => {
  const currentLocale = locale || getCurrentLanguage();
  
  if (currentLocale === 'cs-CZ') {
    return '';
  }
  
  return `1 € = ${EUR_TO_CZK_RATE} Kč`;
};

/**
 * Get currency symbol for current locale
 * @param {string} locale - Current locale
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = (locale = null) => {
  const currentLocale = locale || getCurrentLanguage();
  return currentLocale === 'cs-CZ' ? 'Kč' : '€';
};

/**
 * Check if price should be converted (non-Czech locales)
 * @param {string} locale - Current locale
 * @returns {boolean} True if conversion needed
 */
export const shouldConvertCurrency = (locale = null) => {
  const currentLocale = locale || getCurrentLanguage();
  return currentLocale !== 'cs-CZ';
};
